"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftNav = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var iconButton_1 = require("../../action/iconButton");
var container_1 = require("../../structure/container");
var bars_1 = require("../bars");
var LeftNav = /** @class */ (function (_super) {
    __extends(LeftNav, _super);
    function LeftNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderBars = function () {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "flex flex-col space-y-1" },
                    react_1.default.createElement(bars_1.Bars, { primaryColor: true, bars: _this.props.navigation, selectedId: _this.props.selectedId, draggable: _this.props.draggable, custom: _this.props.custom, linkType: _this.props.linkType, collapse: (_a = _this.props.transition) === null || _a === void 0 ? void 0 : _a.collapse, handleChangeBars: function (value) {
                            if (_this.props.handleChangeNavigation)
                                _this.props.handleChangeNavigation(value);
                        }, handleDropEnd: _this.props.handleDropEnd })),
                react_1.default.createElement("div", { className: "grow" }),
                _this.props.renderDashboardFooterContent && (react_1.default.createElement("div", { className: "flex flex-shrink-0 border-t border-gray-200 p-4" }, _this.props.renderDashboardFooterContent()))));
        };
        _this.renderCollapseIcon = function () {
            var _a, _b;
            if (_this.props.handleToggleCollapse &&
                ((_a = _this.props.transition) === null || _a === void 0 ? void 0 : _a.collapse) !== undefined) {
                if ((_b = _this.props.transition) === null || _b === void 0 ? void 0 : _b.collapse) {
                    return (react_1.default.createElement(outline_1.ArrowRightIcon, { className: "w-10 h-10 text-primary-500 hover:bg-primary-200 rounded-md p-2 hover:cursor-pointer", onClick: _this.props.handleToggleCollapse }));
                }
                else {
                    return (react_1.default.createElement(outline_1.ArrowLeftIcon, { className: "w-10 h-10 text-primary-500 mr-4 hover:bg-primary-200 rounded-md p-2 hover:cursor-pointer", onClick: _this.props.handleToggleCollapse }));
                }
            }
            return react_1.default.createElement(react_1.default.Fragment, null);
        };
        _this.renderDashboardHeader = function () {
            var _a, _b;
            if (((_a = _this.props.transition) === null || _a === void 0 ? void 0 : _a.headerVisible) === undefined ||
                ((_b = _this.props.transition) === null || _b === void 0 ? void 0 : _b.headerVisible)) {
                return (react_1.default.createElement("div", { className: "relative flex-shrink-0 flex h-16 bg-white shadow border-b border-gray-200 lg:border-none" },
                    react_1.default.createElement(iconButton_1.IconButton, { icon: react_1.default.createElement(outline_1.Bars3Icon, { className: "h-5 w-5 text-gray-400" }), className: "px-4 border-r rounded-md border-gray-200 lg:hidden", onClick: _this.props.handleToggleLeftNavMobileMenu }),
                    react_1.default.createElement(container_1.Container, { bgColor: "bg-white", className: "h-full" }, _this.props.renderDashboardHeaderContent())));
            }
            return (react_1.default.createElement("div", { className: "relative flex-shrink-0 flex h-16 bg-white shadow border-b border-gray-200 lg:border-none lg:hidden" },
                react_1.default.createElement(iconButton_1.IconButton, { icon: react_1.default.createElement(outline_1.Bars3Icon, { className: "h-5 w-5 text-gray-400" }), className: "px-4 border-r rounded-md border-gray-200 lg:hidden", onClick: _this.props.handleToggleLeftNavMobileMenu })));
        };
        _this.renderLeftNav = function () {
            var _a, _b, _c, _d;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                _this.props.leftNavMobileMenu && (react_1.default.createElement("div", { className: "fixed inset-0 flex z-40 lg:hidden", role: "dialog", "aria-modal": "true" },
                    react_1.default.createElement("div", { className: "fixed inset-0 bg-gray-600 bg-opacity-75", onClick: _this.props.handleToggleLeftNavMobileMenu, "aria-hidden": "true" }),
                    react_1.default.createElement("div", { className: "relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white" },
                        react_1.default.createElement("div", { className: "absolute top-0 right-0 -mr-12 pt-2" },
                            react_1.default.createElement(iconButton_1.IconButton, { icon: react_1.default.createElement(outline_1.XMarkIcon, { className: "h-5 w-5 text-white" }), background: "bg-transparent", className: "text-white ml-1 rounded-md flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white", onClick: _this.props.handleToggleLeftNavMobileMenu })),
                        _this.props.renderDashboardLogo(),
                        react_1.default.createElement("div", { className: "mt-5 flex-1 h-0 overflow-y-auto" },
                            react_1.default.createElement("nav", { className: "flex flex-col px-2 h-full" }, _this.renderBars()))),
                    react_1.default.createElement("div", { className: "flex-shrink-0 w-14", "aria-hidden": "true" }))),
                react_1.default.createElement("div", { className: "hidden lg:flex lg:flex-shrink-0" },
                    react_1.default.createElement("div", { className: "flex flex-col ".concat(((_a = _this.props.transition) === null || _a === void 0 ? void 0 : _a.collapse) ? "w-20" : "w-64", " border-r border-gray-200 pt-5 pb-4 bg-white") },
                        react_1.default.createElement("div", { className: "flex flex-row ".concat(((_b = _this.props.transition) === null || _b === void 0 ? void 0 : _b.collapse)
                                ? "justify-center"
                                : "justify-between", " items-center") },
                            !((_c = _this.props.transition) === null || _c === void 0 ? void 0 : _c.collapse) &&
                                _this.props.renderDashboardLogo(),
                            react_1.default.createElement("div", { className: "flex h-full ".concat(((_d = _this.props.transition) === null || _d === void 0 ? void 0 : _d.collapse)
                                    ? "justify-center"
                                    : "justify-start") }, _this.renderCollapseIcon())),
                        react_1.default.createElement("div", { className: "h-0 flex-1 flex flex-col overflow-y-auto" },
                            react_1.default.createElement("nav", { className: "flex flex-col px-3 mt-6 h-full" }, _this.renderBars()))))));
        };
        return _this;
    }
    LeftNav.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "h-screen flex overflow-hidden bg-gray-100" },
            this.renderLeftNav(),
            react_1.default.createElement("div", { className: "flex-1 overflow-auto focus:outline-none" },
                this.renderDashboardHeader(),
                react_1.default.createElement("main", { className: "flex-1 relative pb-8 z-0 overflow-y-auto" }, this.props.renderDashboardContent()))));
    };
    return LeftNav;
}(react_1.Component));
exports.LeftNav = LeftNav;
//# sourceMappingURL=index.js.map